import angular from "angular"

angular.module("uCountitUiApp").factory("AnnouncementSrv", function ($rootScope, $resource) {
  const Query = $resource(
    $rootScope.globalConfig.apipath + "/announcement",
    {},
    {
      get: {
        method: "GET",
        isArray: true,
      },
      create: {
        method: "POST",
      },
    }
  )

  const getAnnouncements = (language, callback) => {
    const at = new Date()
      .toISOString()
      .replace(/[-:T.]/g, "")
      .slice(0, 14)

    Query.get(
      {
        _: Date.now(),
        language,
        at,
      },
      function (res) {
        if (Array.isArray(res) && res.length > 0) {
          typeof callback === "function" ? callback(res) : undefined
        } else {
          Query.get(
            {
              _: Date.now(),
              language: "en",
              at,
            },
            function (res) {
              if (Array.isArray(res) && res.length > 0) {
                typeof callback === "function" ? callback(res) : undefined
              }
            },
            function (_err) {}
          )
        }
      },
      function (_err) {}
    )
  }

  return {
    Query,
    getAnnouncements,
  }
})
